import moment from "moment";

import request from "./request";

export const getEventScheduled = async (eventType, trainingId, crewId, baseIds) => {
  const params = new URLSearchParams();
  baseIds?.forEach((id) => params.append("baseIds", String(id)));
  const queryString = params.toString() ? `?${params.toString()}` : "";
  const json = await request(`/schedule/${eventType}/${trainingId}/${crewId}${queryString}`);
  return json;
};

export const addSchedule = async (body) => {
  body.startDateText = moment(body.scheduleTrainingStartDate).format("DD.MM.YYYY HH:mm");
  body.endDateText = moment(body.scheduleTrainingEndDate).format("DD.MM.YYYY HH:mm");
  const response = await request(`/schedule`, "POST", body);
  return response;
};

export const deleteScheduleSlotById = async (slotId) => {
  const json = await request(`/schedule/${slotId}`, "DELETE");
  return json;
};
